import React from "react";
import { Alert, Spinner } from "react-bootstrap";
import { DURATION_LABELS, SURFACE_LABELS, ENCLOSURE_LABELS, SPORT_LABELS } from "../../../constants/courtDomain";

const formatPrice = (price) =>
  typeof price === "number" && price > 0 ? `$${price.toLocaleString("es-AR")}` : "Consultar";

/**
 * Pure presentational sport tabs / duration tabs / court list picker,
 * extracted from QuickSlotModal (design.md V3). No network calls, no
 * navigation, no auth awareness — reused by the buyer quick-slot modal
 * and the organizer internal-reservation modal.
 */
export default function CourtSlotAvailabilityPicker({
  sports,
  activeSport,
  onSportChange,
  durations,
  activeDuration,
  onDurationChange,
  loading,
  loadError,
  courtOptions,
  selectedCourtId,
  onSelectCourt,
  slot,
}) {
  return (
    <>
      {sports.length > 0 && (
        <div className="quick-slot-sport-tabs">
          {sports.map((s) => (
            <button
              type="button"
              key={s}
              className={`duration-opt-btn${activeSport === s ? " active" : ""}`}
              onClick={() => onSportChange(s)}
            >
              {(SPORT_LABELS[s] || s).toUpperCase()}
            </button>
          ))}
        </div>
      )}
      <div className="quick-slot-duration-tabs">
        {durations.map((d) => (
          <button
            type="button"
            key={d}
            className={`duration-opt-btn${activeDuration === d ? " active" : ""}`}
            onClick={() => onDurationChange(d)}
          >
            {(DURATION_LABELS[d] || `${d} min`).toUpperCase()}
          </button>
        ))}
      </div>

      {loadError && <Alert variant="danger">{loadError}</Alert>}

      {loading ? (
        <div style={{ textAlign: "center", padding: "24px 0" }}>
          <Spinner animation="border" style={{ color: "var(--zoco-lime-strong)" }} />
        </div>
      ) : courtOptions.length === 0 ? (
        <div style={{ padding: "16px 0", fontSize: 14, color: "#6b7280" }}>
          No hay canchas disponibles para esta duración a las {slot?.slotStart} hs.
        </div>
      ) : (
        <div className="quick-slot-courts-list">
          {courtOptions.map(({ court, entry }) => (
            <button
              type="button"
              key={court.courtId}
              className={`quick-slot-court-row${selectedCourtId === court.courtId ? " active" : ""}`}
              onClick={() => onSelectCourt(court.courtId)}
            >
              <div className="quick-slot-court-info">
                <span className="name">{court.name}</span>
                <span className="meta">
                  {[SURFACE_LABELS[court.surface] || court.surface, ENCLOSURE_LABELS[court.enclosure] || court.enclosure]
                    .filter(Boolean)
                    .join(" · ")}
                </span>
              </div>
              <span className="quick-slot-court-price">{formatPrice(entry.price)}</span>
            </button>
          ))}
        </div>
      )}
    </>
  );
}
